import { Api } from "../../api/Api";
import { BooleanThunk } from "../IStore";
import { OperationalUnitDto } from "../models/operationalUnit/OperationalUnitDto";
import { OperationalUnitStatus } from "../models/operationalUnit/OperationalUnitStatus";
import { thunkCreateErrorNotification, thunkCreateSuccessNotification } from "./NotificationActions";

export const GET_OPERATIONAL_UNITS = "GET_OPERATIONAL_UNITS";
export const UPDATE_OPERATIONAL_UNIT = "UPDATE_OPERATIONAL_UNIT";
export const GET_DEFAULT_OPERATIONAL_UNIT_TYPES = "GET_DEFAULT_OPERATIONAL_UNIT_TYPES";

export const DELETE_OPERATIONAL_UNIT = "DELETE_OPERATIONAL_UNIT";

export const thunkGetOperationalUnits = (): BooleanThunk => async (dispatch) => {
  try {
    const operationalUnits = await Api.getOperationRootUnitList();
    dispatch({
      type: GET_OPERATIONAL_UNITS,
      payload: operationalUnits,
    });
    return true;
  } catch (e) {
    dispatch(thunkCreateErrorNotification("Failed to load branches", e));
    return false;
  }
};

export const thunkUpdateOperationalUnit =
  (operationalUnitToUpdate: OperationalUnitDto): BooleanThunk =>
  async (dispatch) => {
    try {
      // The update answers 204 without a body; the list is re-read from the server.
      await Api.updateOperationalUnit(operationalUnitToUpdate);
      await dispatch(thunkGetOperationalUnits());
      dispatch(thunkCreateSuccessNotification("Die Filiale wurde aktualisiert"));
      return true;
    } catch (e) {
      dispatch(thunkCreateErrorNotification("Failed to update branch", e));
      return false;
    }
  };

export const thunkCreateOperationalUnit =
  (operationalUnitToCreate: OperationalUnitDto): BooleanThunk =>
  async (dispatch) => {
    try {
      // The create answers 201 with a Location header only; the list is re-read from the server.
      await Api.createOperationalUnit(operationalUnitToCreate);
      await dispatch(thunkGetOperationalUnits());
      dispatch(thunkCreateSuccessNotification("Die Filiale wurde angelegt"));
      return true;
    } catch (e) {
      dispatch(thunkCreateErrorNotification("Failed to create the branch", e));
      return false;
    }
  };

export const thunkUpdateOperationalUnitStatus =
  (operationalUnit: OperationalUnitDto, status: OperationalUnitStatus): BooleanThunk =>
  async (dispatch) => {
    try {
      operationalUnit.unitStatus = status;
      await Api.updateOperationalUnitStatus(operationalUnit);
      dispatch({
        type: UPDATE_OPERATIONAL_UNIT,
        payload: operationalUnit,
      });
      dispatch(thunkCreateSuccessNotification("Die Filiale wurde deaktiviert"));
      return true;
    } catch (e) {
      dispatch(thunkCreateErrorNotification("Failed to deactivate the branch", e));
      return false;
    }
  };

export const thunkGetDefaultOperationalUnitTypes = (): BooleanThunk => async (dispatch) => {
  try {
    const operationalUnitTypes = await Api.getDefaultOperationalUnitTypes();
    dispatch({
      type: GET_DEFAULT_OPERATIONAL_UNIT_TYPES,
      payload: operationalUnitTypes,
    });
    return true;
  } catch (e) {
    dispatch(thunkCreateErrorNotification("Failed to load operational units", e));
    return false;
  }
};

export const thunkDeleteOperationalUnit =
  (operationalUnit: OperationalUnitDto): BooleanThunk =>
  async (dispatch) => {
    try {
      await Api.deleteOperationalUnit(operationalUnit);
      dispatch({
        type: DELETE_OPERATIONAL_UNIT,
        payload: operationalUnit,
      });
      dispatch(thunkCreateSuccessNotification("Die Filiale wurde gelöscht"));
      return true;
    } catch (e) {
      dispatch(thunkCreateErrorNotification("Failed to delete the operational unit", e));
      return false;
    }
  };
